export default __webpack_public_path__ + "static/media/TimeLine_EN.ca772cf0.png";